// extracted by mini-css-extract-plugin
module.exports = {"wallet":"SpWallet_wallet__1Vc6V","balance":"SpWallet_balance__2GGPX","button":"SpWallet_button__3peN7"};